import TextUs from 'components/Content/CustomerService/TextUs/TextUs';

export default TextUs;
